import { Box, IconButton, useTheme } from "@mui/material";
import {
  DownloadOutlined,
  DeleteOutlined,
  DescriptionOutlined,
} from "@mui/icons-material";
import { tokens } from "../../../../theme";
import AnimatedTable, { ColumnDef } from "../AnimatedTable";
import Button from "../../../../components/common/Button";

const mockDocuments = [
  {
    id: 1,
    file: "Manual_FX6_v2.pdf",
    type: "PDF",
    uploadedBy: "Tawanda Kamhamba",
    date: "2026-07-15",
    size: "4.1 MB",
  },
  {
    id: 2,
    file: "Receipt",
    type: "Excel",
    uploadedBy: "Mark Johnson",
    date: "2023-10-05",
    size: "2.3 MB",
  },
  {
    id: 3,
    file: "Doc.rqcode",
    type: "QR Code",
    uploadedBy: "Jessica Smith",
    date: "2023-09-01",
    size: "150 KB",
  },
];

export default function DocumentsTab() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns: ColumnDef<(typeof mockDocuments)[0]>[] = [
    {
      key: "file",
      label: "File",
      cellSx: { fontWeight: 500, color: theme.palette.text.primary },
      render: (row) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DescriptionOutlined
            sx={{ fontSize: 18, color: theme.palette.text.secondary }}
          />
          {row.file}
        </Box>
      ),
    },
    { key: "type", label: "Type", render: (row) => row.type },
    {
      key: "uploadedBy",
      label: "Uploaded by",
      render: (row) => row.uploadedBy,
    },
    { key: "date", label: "Date", render: (row) => row.date },
    { key: "size", label: "Size", render: (row) => row.size },
    {
      key: "action",
      label: "Action",
      render: () => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
            <DownloadOutlined fontSize="small" />
          </IconButton>
          <IconButton size="small" sx={{ color: "#d32f2f" }}>
            <DeleteOutlined fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: colors.primary[400],
            color: colors.primary[900],
            textTransform: "none",
            borderRadius: "8px",
            fontWeight: 600,
            "&:hover": { backgroundColor: colors.primary[50] },
          }}
        >
          Upload
        </Button>
      </Box>
      <AnimatedTable
        columns={columns}
        rows={mockDocuments}
        getRowId={(row) => row.id}
        page={0}
        totalPages={1}
        onPageChange={() => {}}
        emptyMessage="No documents found."
      />
    </Box>
  );
}
